import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Form } from "@ui/form/Form";
import { useState } from "react";
import { GD } from "src/GD";
import { S_AUTH_CHANGE_VIEW } from "./AuthSignals";
import { registrationForm, TAuthRegister } from "./RegisterView";

export const RegisterStep2 = () => {
	useLocale();
	const [formData, setFormData] = useState<TAuthRegister>(registrationForm.step2);

	const validate = (): boolean => {
		if (!registrationForm.step2.email || registrationForm.step2.email === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("pleaseProvideEmail"),
				},
			});
			return false;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (registrationForm.step2.email && !emailRegex.test(registrationForm.step2.email)) {
			// setError({
			// 	code: -1,
			// 	message: "Email not valid",
			// });
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("emailNotValid"),
				},
			});
			return false;
		}

		if (!registrationForm.step2.password || registrationForm.step2.password === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("pleaseEnterPassword"),
				},
			});
			return false;
		}

		if (!registrationForm.step2.confirm_password || registrationForm.step2.confirm_password === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("pleaseEnterConfirmPassword"),
				},
			});
			return false;
		}

		if (registrationForm.step2.password && registrationForm.step2.password.length < 5) {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("passwordTooShort"),
				},
			});
			return false;
		}

		if (registrationForm.step2.password !== registrationForm.step2.confirm_password) {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("passwordsDoNotMatch"),
				},
			});
			return false;
		}

		if (!registrationForm.step2.full_name || registrationForm.step2.full_name === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: {
					code: -1,
					message: msg("pleaseEnterFullName"),
				},
			});
			return false;
		}

		return true;
	};

	const handleSubmit = async () => {
		if (validate()) {
			GD.REQ_STEP_BUSY.invoke(false);

			GD.REG_STEP_ERROR.invoke({
				step: "step2",
				error: null,
			});
			const response = await GD.REQ_API.request({
				method: "users/mail/check/request",
				data: {
					email: registrationForm.step2.email,
				},
			});
			GD.REQ_STEP_BUSY.invoke(false);

			if (response && response.data) S_AUTH_CHANGE_VIEW.invoke("reg3");
			else
				GD.REG_STEP_ERROR.invoke({
					step: "step2",
					error: response?.error ?? {
						code: -1,
						message: msg("unknownError"),
					},
				});
		}
	};

	//todo: request company check!

	return (
		<>
			{formData && (
				<Form
					sx={{ gap: "30px" }}
					data={formData}
					//error={saveResult}
					onSubmit={() => handleSubmit()}
					onChange={form => {
						registrationForm.step2 = form;
						setFormData(form);
					}}
					submitTitle="Continue"
					fullWidthButton
				/>
			)}
		</>
	);
};
